module["exports"] = [
  "կարմիր",
  "կանաչ",
  "կապույտ",
  "դեղին",
  "մանուշակագույն",
  "սպիտակ",
  "սև",
  "նարնջագույն",
  "վարդագույն",
  "մոխրագույն",
  "երկնագույն",
  "ոսկեգույն"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/hy/commerce/color.js
// module id = 3070
// module chunks = 1610